import script from "./Interface.vue?vue&type=script&setup=true&lang=js"
export * from "./Interface.vue?vue&type=script&setup=true&lang=js"

import "./Interface.vue?vue&type=style&index=0&id=4eeb191e&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eeb191e"]])

export default __exports__